import {lightModeSvg as Icon__small__lightModeSvg} from '../Icon__small/Icon__small--lightMode.js';

export var lightMode = {
  name: 'lightMode',
  category: 'icon',
  colorable: true,
  svg: Icon__small__lightModeSvg,
};
